import { IsEmpty, IsNotEmpty } from "./Helpers";

export class I18N {
    private static _variables: object = {}
    private static _curLanguage: string;
    private static _isInitialized: boolean = false;

    public static async Init(language: string, sources: string[]) {
        I18N._curLanguage = I18N.Get4DigitIsoLanguage(language);

        var tasks = sources.map(async s => {
            let json = null;
            let response = await fetch(`/I18N/${s}.${I18N._curLanguage}.json`, {
                method: 'get',
                credentials: 'include',
                headers: [
                    ['Content-Type', 'application/json'],
                ]
            });

            try {
                json = await response.json();
            }
            catch {
                try {
                    if (I18N._curLanguage.includes('-')) {
                        response = await fetch(`/I18N/${s}.${I18N._curLanguage.split('-')[0]}.json`, {
                            method: 'get',
                            credentials: 'include',
                            headers: [
                                ['Content-Type', 'application/json'],
                            ]
                        });
                        json = await response.json();
                    }
                }
                catch {

                }
            }

            if (json !== null) {
                I18N._variables = { ...I18N._variables, ...json };
            }
            else {
                console.error(`Failed to download ${s} for language ${I18N._curLanguage}`);
            }
        });

        for (let i = 0; i < tasks.length; i++) {
            await tasks[i];
        }
        I18N._isInitialized = true;
    }
    public static get CurrentLanguage() { return I18N._curLanguage; }
    public static Translate(instr: string) {
        if (I18N._isInitialized && IsNotEmpty(instr) && IsEmpty(I18N._variables[instr])) {
            //console.info(`I18N Missing value for: [${instr}]`);
            console.info(`"${instr}": "${instr}",`);
        }
        return I18N._variables[instr] ?? instr;
    }

    private static Get4DigitIsoLanguage(inLanguage: string) {
        if (['zh', 'zh-cn', 'zh-hk', 'zh-sg', 'zh-tw'].includes(inLanguage.toLowerCase()))
            return 'zh-CN';
        else if (['ru', 'ru-ru', 'rus'].includes(inLanguage.toLowerCase()))
            return 'ru-RU'
        else if (['es-mx', 'es'].includes(inLanguage.toLowerCase()) || inLanguage.toLowerCase().startsWith('es-'))
            return 'es-MX';
        else if (['pt', 'pt-pt'].includes(inLanguage.toLowerCase()) || inLanguage.toLowerCase().startsWith('pt-'))
            return 'pt-PT';

        return 'en-US';
    }
}
